import axios from 'axios'
import productMockApi from '@/api/mock/productMockApi'
const url = process.env.API_PRODUCT_URL

const productApi = {
  getProduct (productId, providerId) {
    return axios.get(`${url}/products/${productId}/provider/${providerId}`)
      .catch(function (error) {
        console.error(error)
      })
  },
  getProviders () {
    return axios.get(`${url}/providers`)
  }
}

let api = productApi
try {
  const useMock = process.env.NODE_ENV === 'development' && process.env.API_USE_MOCK === true
  api = useMock ? productMockApi : productApi
} catch (e) {
  console.error('error!')
}

export default api



// WEBPACK FOOTER //
// ./src/api/productApi.js